import { AuthApp } from "components/auth-app";
import { NotificationProvider } from "components/notifications/context";
import { CoverageContextProvider } from "pages/overview/extended-coverages/hooks";
import { CoverageContextProvider as ExtendedCoveragesContextProvider } from "pages/policy/extended-coverages/hooks";

const AuthAppWrapper = () => (
  <CoverageContextProvider>
    <ExtendedCoveragesContextProvider>
      <NotificationProvider>
        <AuthApp />
      </NotificationProvider>
    </ExtendedCoveragesContextProvider>
  </CoverageContextProvider>
);

export default AuthAppWrapper;
